import type { BoardCard } from "../../../../lib/giftingRules";
import { STAGE_NAMES, ageLabel } from "../../../../lib/giftingRules";
import { GfStageBar } from "../../ui/GfUi";
import type { CardInfo } from "./model";

/** 待ちカード（コンパクト1行・背景 #F4F3EF） */
export function WaitCard({
  card,
  info,
  selected,
  onOpen,
}: {
  card: BoardCard;
  info: CardInfo;
  selected: boolean;
  onOpen: () => void;
}) {
  const { entry: e, age } = card;
  return (
    <button type="button" className={`gf-wait${selected ? " is-selected" : ""}`} onClick={onOpen}>
      <span className="gf-wait-id">
        <span className="gf-wait-name">{info.creatorName}</span>
        <span className="gf-wait-sub">
          {STAGE_NAMES[e.stage]}・{info.campaignName}
        </span>
      </span>
      <GfStageBar stage={e.stage} height={4} />
      <span className="gf-wait-age">{ageLabel(age)}</span>
    </button>
  );
}
